module.exports = __webpack_public_path__ + "img/symbol_6.8198fcb3.png";